<template>
  <div class="body evel-II">
    <zdylayout>
      <template v-slot:query-box-filed> 
        <el-form
        ref="form"
        :model="condition"
        label-width="80px"
        @submit.native.prevent
        class="operationControl"
          :inline="true"
          label-suffix=":"
          size="small"
      >

            <el-form-item label="课件名称" prop="dataName">
              <el-input
                size="small"
                v-model="condition.dataName"
                @keyup.enter.native="search"
                class="width150"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="创建时间" prop="date">
              <el-date-picker
                v-model="condition.date"
                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                class="width350"
              ></el-date-picker>
            </el-form-item>

            <!-- <el-form-item label="课件目录" prop="directoryId" class="clear">
              <selectTree
                clearable
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList"
                :value="condition.directoryId"
                @getValue="selectTreeChange"
                class="width150"
              ></selectTree>
            </el-form-item>

            <el-form-item label="行业选择" prop="professionalCategoryName">
              <dictionarySelect
                ref="professionalCategorySelect"
                :parentCode="$const.dictionary.TRAINING_INDUSTRY"
                :filter="true"
                @submit="professionalCategorySubmitHandle"
                class="width150"
                clearable
              ></dictionarySelect>
            </el-form-item> -->
            <div class="fa-pull-right">
            <el-form-item >
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </div>
      </el-form>
      </template>
      <template v-slot:query-box-button> </template>
      <template v-slot:layer-body-front>
        <div class="fl">
          <el-button
          type="primary"
          icon="el-icon-delete"
          :disabled="resourcesIds.length < 1"
          @click="removeList"
          >批量删除
        </el-button>

        <!-- <el-button @click="shows()">导入新增课件</el-button> -->
        </div>
        <div class="fa-pull-right">
          <el-button
          type="primary"
          icon="el-icon-plus"
          @click="$router.push('/trainingManagement/trainingResourceAdd')"
          >新增
        </el-button>
        </div>
      </template>
      <template v-slot:body-table>
        <el-table
          class="common_tables"
          row-key="id"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          style="width: 100%"
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
        >
          <el-table-column reserve-selection type="selection" width="55">
          </el-table-column>
          <el-table-column
            type="index"
            width="60"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="dataName"
            label="课件名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <!-- <el-table-column>
            <template slot="header" slot-scope="scope">
              <span>来源</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div
                  slot="content"
                  v-html="courseUtils.sourceTooltipExplain()"
                ></div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-html="courseUtils.translateSourceName(scope.row)"></span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="dataIntroduction"
            label="课件简介"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="teacherName"
            label="教师名称"
          ></el-table-column>
          <!--        <el-table-column width="200" label="专业类别"-->
          <!--                         :show-overflow-tooltip="true">-->
          <!--          <template slot-scope="scope">-->
          <!--            <span v-if="scope.row.professionalCategoryName" v-html="scope.row.professionalCategoryName">-->
          <!--            </span>-->
          <!--            <span v-else>-->
          <!--               &#45;&#45;-->
          <!--            </span>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column
            prop="createdTime"
            label="创建时间"
            width="160"
          ></el-table-column>
          <!--        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isAble == 0" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>-->
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="
                  $router.push(
                    `/trainingManagement/trainingResourceDetail?id=${scope.row.id}&type=check`
                  )
                "
                >详情
              </el-button>

              <el-button
                size="mini"
                type="primary"
                @click="
                  $router.push(
                    `/trainingManagement/trainingResourceUpdate?id=${scope.row.id}`
                  )
                "
                >编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="
                  delData(
                    scope.row.id,
                    0,
                    scope.row.isMallImport == null ? 2 : scope.row.isMallImport
                  )
                "
                >删除
              </el-button>
              <!--            <el-button
                  size="mini"
                  @click="delData(scope.row.id,1,-2)"
                  type="warning"
                  v-if="scope.row.isAble == 0"
                >禁用
                </el-button>
                <el-button size="mini" @click="delData(scope.row.id,1,-2)" type="success" v-else>启用</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:body-pagination>
        <div class="common_btm_pagination">
          <el-pagination
            background
            @size-change="sizeChange"
            :current-page="page"
            @current-change="pageChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </template>
    </zdylayout>

    <div>
      <el-dialog title="提示" :visible.sync="dialogVisibles" width="50%">
        <div style="height: 600px; padding: 20px; overflow: auto">
          <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <el-row>
              <el-col :span="24" class="pr20">
                <el-form-item label="课件名称" prop="dataName" class="item">
                  <el-input v-model="form.dataName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="pr20">
                <el-form-item label="目录" prop="questionsDirectoryId">
                  <selectTree
                    :props="{
                      value: 'id', // ID字段名
                      label: 'directoryName', // 显示名称
                      children: 'directoryList' // 子级字段名
                    }"
                    :options="catalogList"
                    :value="form.questionsDirectoryId"
                    @getValue="directoryChange"
                  ></selectTree>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="mb20">
              <el-col :span="24" class="pr20">
                <el-form-item label="教师名称" prop="teacherName" class="item">
                  <el-input v-model="form.teacherName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="mb20">
              <el-col :span="24" class="pr20">
                <el-form-item label="课件简介" prop="dataIntroduction">
                  <el-input
                    type="textarea"
                    v-model="form.dataIntroduction"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="mb20">
              <el-col :span="24" class="pr20">
                <el-form-item label="模板上传">
                  <oss-upload
                    :is-slot="false"
                    :limit="0"
                    :limitSize="1"
                    :type="'temp'"
                    showFileLis="true"
                    :accept="'.xlsx'"
                    :drag="true"
                    :showFileList="false"
                    :isSlot="false"
                    :onElSuccess="onOssSuccess"
                    @onBefore="onOssBefore"
                  >
                    <!--                    <el-button v-show="!loading" size="small" type="primary">点击上传</el-button>-->
                  </oss-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <!--          <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button type="primary" @click="commits()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import selectTree from "@/components/common/selectTree";
import exam from "@/api/new/exam.js";
import $const from "@/common/constant";

import api from "../../api/new/training.js";
import DIC_API from "@/api/api_dictionary";
import dictionarySelect from "@/components/common/dictionarySelect";
import config from "@/config/config.js";

import courseUtils from "@/common/courseUtils.js";
import ossUpload from "@/components/common/oss/ossUpload";
import VideoAPI from "@/api/video/api_video.js";
export default {
  components: { selectTree, dictionarySelect, ossUpload },
  data() {
    return {
      dialogVisibles: false,
      //课件参数
      rules: {
        dataName: [
          { required: true, message: "请输入课件名称", trigger: "blur" }
        ],
        dataIntroduction: [
          { required: true, message: "请输入课件简介", trigger: "blur" }
        ],
        questionsDirectoryId: [
          { required: true, message: "请选择目录", trigger: "blur" }
        ],
        teacherName: [
          { required: true, message: "教师名不能为空", trigger: "blur" }
        ]
      },
      form: {
        dataName: "",
        dataIntroduction: "",

        professionalCategoryName: "", // 专业类别名称
        professionalCategory: "", // 专业类别
        professionalCategoryItem: "",
        professionalCategorySubItem: "",

        department: "", //部门
        // departmentId: "", // 部门id
        questionsDirectoryId: "",
        questionsDirectoryName: "",
        teacherName: undefined,
        importUrl: undefined
      },

      //课件参数

      resourcesIds: [],
      config: config,
      courseUtils: courseUtils,
      $const: $const,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      condition: {
        dataName: "",
        dataIntroduction: "",
        startCreateTime: "",
        endCreateTime: "",
        professionalCategory: "",
        directoryId: undefined,
        date: [],
        professionalCategoryName: undefined
      },
      catalogList: [], //目录列表
      tableLoading: true
    };
  },
  mounted() {
    this.getDataList();
    this.getCatalogList();
    window.addEventListener("pageshow", this.onShow); //不能写成this.onShow()
  },
  methods: {
    /** 课件开始**/
    commits() {
      this.$refs.form.validate(validate => {
        if (validate) {
          if (this.form.importUrl == undefined || this.form.importUrl == "") {
            this.$message("请上传模板文件！！");
            return false;
          }
          console.log(this.form);
          VideoAPI.save(this.form)
            .then(res => {
              console.log(res);
              if (res.code === 0) {
                this.$message({
                  message: "上传成功",
                  type: "success"
                });
                this.resetResoure();
                this.dialogVisibles = false;
              } else {
                this.$message.error("请查看模板是否正确或者是否缺失数据！！");
              }
            })
            .catch(err => {
              this.$message.error("请查看模板是否正确或者是否缺失数据！！");
              // 报错
              console.log(err);
            });
        }
      });
    },
    directoryChange(v) {
      console.log(v);

      this.selectCatalogue = v;
      this.form.questionsDirectoryId = v.id;
      this.form.questionsDirectoryName = v.text;
    },
    onOssBefore() {
      this.importMsg = "正在上传文件中...";
    },
    resetResoure() {
      this.form = {
        dataName: "",
        dataIntroduction: "",
        professionalCategoryName: "", // 专业类别名称
        professionalCategory: "", // 专业类别
        professionalCategoryItem: "",
        professionalCategorySubItem: "",
        department: "", //部门
        questionsDirectoryId: "",
        questionsDirectoryName: "",
        teacherName: undefined,
        importUrl: undefined
      };
    },
    shows() {
      this.resetResoure();

      this.dialogVisibles = true;
    },
    onOssSuccess(data) {
      this.form.importUrl = undefined;
      if (data) {
        if (data.code === 0) {
          this.$message({
            message: "上传成功",
            type: "success"
          });

          this.form.importUrl = data.key;
        } else {
          this.$message.error("上传失败，请重试！！！");
        }
      } else {
        this.$message.error("上传失败，请重试！！！");
      }

      console.log(data);
    },
    /** 课件结束**/
    removeList() {
      let datas = "";
      api.removeList(this.resourcesIds).then(res => {
        console.log(res);

        if (res.code === 0) {
          if (res.data.code === 0) {
            datas = "操作成功";

            this.$refs.multipleTable.clearSelection();
            this.getDataList();

            if (res.data.codes === -1) {
              datas += "，所选课件中包含已绑定课件，已无法删除";

              // setTimeout(() =>{
              //   this.$message.error(res.data.msgs);
              // },1000);
            }

            this.$message.success(datas);
          } else {
            this.$message.error(res.data.msg);
          }
        }
      });
    },
    handleSelectionChange(data) {
      this.resourcesIds = [];
      data.forEach(item => {
        // this.resourcesIds.push(item.sourceId);
        this.resourcesIds.push(item.id);
      });
    },

    professionalCategorySubmitHandle(data) {
      if (data) {
        this.condition.professionalCategoryName = data.pathTextName;
      } else {
        this.condition.professionalCategoryName = undefined;
      }
    },
    onShow() {
      this.getDataList();
    },
    /**
     * 查询课件
     */
    search() {
      this.page = 1;
      this.getDataList();
    },
    //获取课件列表
    getDataList() {
      let condition = this.condition;
      let p = {
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };

      if (condition.professionalCategoryName) {
        p.professionalCategoryName = condition.professionalCategoryName;
      }

      if (condition.dataName) p.dataName = condition.dataName;
      if (condition.dataIntroduction)
        p.dataIntroduction = condition.dataIntroduction;
      if (condition.professionalCategory)
        p.professionalCategory = condition.professionalCategory;
      if (condition.directoryId) p.directoryId = condition.directoryId;
      if (condition.date && condition.date.length > 0) {
        p.startCreateTime = new Date(condition.date[0]).getTime();
        p.endCreateTime = new Date(condition.date[1]).getTime();
      }

      this.tableLoading = true;
      // api.getDataList(p).then(res => {
      //getPageResourcesList
      api.pageResourcesListRewrite(p).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    /**
     * 删除或者禁用单条课件
     * status:状态(0,删除 1、禁用)
     */
    delData(dataId, status, type) {
      console.log(type);
      const enterpriseId = JSON.parse(localStorage.getItem("userinfo"))
        .enterpriseId;
      if (status == 0) {
        this.$confirm("此操作将删除该课件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          api
            .delData({
              dataId,
              status,
              type,
              enterpriseId
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success("成功");
                this.getDataList();
              } else {
                this.$message.error(res.message);
              }
            });
        });
      } else {
        api
          .delData({
            dataId,
            status,
            type,
            enterpriseId
          })
          .then(res => {
            if (res.code == 0) {
              this.$message.success("成功");
              this.getDataList();
            }
          });
      }
    },

    handleClick(row) {
      console.log(row);
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search();
      this.$refs.professionalCategorySelect.clear();
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getDataList();
    },
    getCatalogList() {
      exam
        .getCatalogList({
          type: 3,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.condition.directoryId = v.id;
    },
    /**
     * 判断是否是运营人员
     */
    isOperating() {
      let userInfo = JSON.parse(localStorage.getItem("userinfo"));
      return userInfo.isOperating;
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;
}

.searchBut {
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/trainingResource.vue